import { observable, configure, action, runInAction } from 'mobx'
import Api from '../utils/api'

configure({ enforceActions: 'always' })

const userStore = observable({
    user: null,
    isLogin: false,
    isLogined: false,
    setUser: action(() => {
        Api.userInfo().then((res) => {
            userStore.isLogin = res?.data?.isLogin || false
            userStore.user = res?.data?.result || null
        }).finally(() => {
            userStore.isLogined = true
        })
    })
})

const categoryStore = observable({
    loaded: false,
    cate: [],
    cateRequest: action((idx_b_manager = 1) => {
        Api.categoryDataAPI(idx_b_manager).then((res) => {
            const cate = res.data.result.cate
            runInAction(() => {
                categoryStore.loaded = true
                categoryStore.cate = cate
            })
        })
    }),
})

export { userStore, categoryStore }



// WEBPACK FOOTER //
// ./src/m_header/stores/store.js